import axios from "@/store/vue-axios"
import {Model} from "@/store/models/model"

export class VserverPrices extends Model {

  static entity = 'vserver_prices'
  static primaryKey = 'unit'

  static fields() {
    return {
      id: this.attr(null),
      unit: this.attr(null),
      max_units: this.attr(null),
      min_units: this.attr(null),
      step: this.attr(null),
      free_units: this.attr(null),
      price: this.attr(null),
      range: this.attr(null)
    }
  }
  static async pricingVservers(){
    const x = await axios.get("/accounting/pricing/vservers")
      .then(response=>{
        console.log('VPRICES:::',response)
        const x = response.data.options
        const y =Object.keys(x)
        const z = y.map(el=>{
          const xx = !VserverPrices.find(el.unit) ? VserverPrices.insertOrUpdate({data:x[el]}) : VserverPrices.update({where:el.unit,data:el})
        })
      })
      .catch(error=>error)
    return x
  }

  static priceCalculator (config) {
    console.log('PRICE CALC CONFIG',config)
    if(VserverPrices.all().length === 0) VserverPrices.pricingVservers()
    /*const dict = {}
    const x = VserverPrices.all().map(el=>{
      dict[el.unit]= config[el.unit] * el.price / el.step
    })*/
    const priceList = VserverPrices.all().map(el=>
      config[el.unit] * el.price / el.step
    )
    const priceSum = Number(priceList.reduce((sum, x) => sum + x)).toFixed(1)
    return priceSum
    }

}

  export default VserverPrices






// WEBPACK FOOTER //
// ./src/store/models/vserver/vserver_prices.js